import LoginPage from './LoginPage/LoginPage';
import DashboardPage from './DashboardPage/DashboardPage';
import ActivationPage from './ActivationPage/ActivationPage';
import BotPage from './BotPage/BotPage';
import GoalsPage from './GoalsPage/GoalsPage';
import SettingsPage from './SettingsPage/SettingsPage';
import React, { useState } from 'react';
import { BotProvider } from '../context/BotContext';

const PAGES = {
    login: LoginPage,
    dashboard: DashboardPage,
    activation: ActivationPage,
    bot: BotPage,
    goals: GoalsPage,
    settings: SettingsPage,
};



const TEMP_PAGES = [
    { key: 'login', label: 'Login' },
    { key: 'dashboard', label: 'Dashboard' },
    { key: 'activation', label: 'Ativação' },
    { key: 'bot', label: 'Bot' },
    { key: 'goals', label: 'Metas' },
    { key: 'settings', label: 'Configurações' },
];

const App = () => {
    const [page, setPage] = useState(() => {
        const user = localStorage.getItem('usuarioLogado');
        return user ? 'dashboard' : 'login';
    });
    const PageComponent = PAGES[page] || LoginPage;

    // Função de logout
    const handleLogout = () => {
        localStorage.removeItem('usuarioLogado');
        setPage('login');
    };

    // Proteger rotas: se não autenticado, sempre redireciona para login
    const isAuthenticated = !!localStorage.getItem('usuarioLogado');
    const protectedPages = ['dashboard', 'activation', 'bot', 'goals', 'settings'];
    if (protectedPages.includes(page) && !isAuthenticated) {
        setPage('login');
        return null;
    }

    // Valores padrão para DashboardPage
    let defaultProps = { onNavigate: setPage, onLogout: handleLogout };
    if (page === 'dashboard') {
        // Recupera saldo do usuário logado
        let balance = 0;
        let availableBalance = 0;
        let isActivated = false;
        try {
            const user = JSON.parse(localStorage.getItem('usuarioLogado'));
            if (user && typeof user.saldoInicial === 'number') {
                balance = user.saldoInicial;
            }
            if (user && typeof user.saldoDisponivel === 'number') {
                availableBalance = user.saldoDisponivel;
            } else {
                availableBalance = balance;
            }
            if (user && user.codigoAtivo) {
                isActivated = true;
            }
        } catch (e) { }
        defaultProps = { ...defaultProps, balance, availableBalance, isActivated };
    }

    // Bloquear acesso à seção de operar (bot) se não ativado
    if (page === 'bot') {
        let isActivated = false;
        let balance = 0;
        let availableBalance = 0;
        try {
            const user = JSON.parse(localStorage.getItem('usuarioLogado'));
            if (user && user.codigoAtivo) {
                isActivated = true;
            }
            if (user && typeof user.saldoInicial === 'number') {
                balance = user.saldoInicial;
            }
            if (user && typeof user.saldoDisponivel === 'number') {
                availableBalance = user.saldoDisponivel;
            } else {
                availableBalance = balance;
            }
        } catch (e) { }
        if (!isActivated) {
            setPage('activation');
            return null;
        }
        // Função para atualizar saldo do usuário
        const onBalanceUpdate = (newBalance, newAvailableBalance) => {
            try {
                const user = JSON.parse(localStorage.getItem('usuarioLogado'));
                if (user) {
                    user.saldoInicial = newBalance;
                    user.saldoDisponivel = newAvailableBalance;
                    localStorage.setItem('usuarioLogado', JSON.stringify(user));
                    // Atualiza também no prisma_users
                    const users = JSON.parse(localStorage.getItem('prisma_users') || '[]');
                    const idx = users.findIndex(u => u.email === user.email);
                    if (idx !== -1) {
                        users[idx].saldoInicial = newBalance;
                        users[idx].saldoDisponivel = newAvailableBalance;
                        localStorage.setItem('prisma_users', JSON.stringify(users));
                    }
                }
            } catch (e) { }
        };
        defaultProps = { ...defaultProps, balance, availableBalance, isRunning: false, onBalanceUpdate };
    }

    // Obter e-mail do usuário logado para usar como key
    let userEmail = '';
    try {
        const user = JSON.parse(localStorage.getItem('usuarioLogado'));
        if (user && user.email) userEmail = user.email;
    } catch (e) { }

    return (
        <BotProvider key={userEmail}>
            <PageComponent {...defaultProps} />
        </BotProvider>
    );
};

export default App;